// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageSection-module--container--3Wbwc","overlay":"ImageSection-module--overlay--kDeyZ","titleWrap":"ImageSection-module--titleWrap--3ALNC"};